import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";
import FormulaValue from "../../../components/formula-value";
import FormulaName from "../../../components/formula-name";
import { batchRequest } from '../../../../../api/ApiService';
import { Loader } from 'react-loaders';

class GrossMarginsStep2 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      sellingPrice: 0,
      unitCost: 0,
      grossMargin: 0,
    };
  }

  componentDidMount() {
    const { activeRound, rounds } = this.props;
    const round = rounds.find(i => i.number === activeRound);
    const roundId = round ? round.id : 0;

    batchRequest([
      `${process.env.REACT_APP_API_URL}team/report/metrics/?round_number=${activeRound}`,
      `${process.env.REACT_APP_API_URL}team/report/income_statement/?round_number=${activeRound}`,
      `${process.env.REACT_APP_API_URL}v2/games/targets/`,
    ])
      .then(res => {
        const metrics = res[0].body;
        const currentRoundMetrics = metrics.find(i => i.round_number === activeRound);

        const netRevenues = currentRoundMetrics ? Number(currentRoundMetrics['Net Revenues'] || 0) : 0;
        const unitsSold = currentRoundMetrics ? Number(currentRoundMetrics['Units Sold'] || 0) : 0;
        const sellingPrice = unitsSold !== 0 ? Math.abs(netRevenues / unitsSold) : 0;

        const incomeStatement = res[1].body;
        const currentRoundIncomeStatement = incomeStatement.find(i => i.round === roundId);
        const costOfSales = currentRoundIncomeStatement ? Number(currentRoundIncomeStatement['Cost of Sales'] || 0) : 0;
        const unitCost = unitsSold !== 0 ? Math.abs(costOfSales / unitsSold) : 0;

        const targets = res[2].body;
        const currentRoundTargets = targets.find(i => i.round_number === activeRound);

        this.setState({
          loaded: true,
          sellingPrice,
          unitCost,
          grossMargin: Number(currentRoundTargets.gross_margin || 0),
        })
      })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      sellingPrice,
      unitCost,
      grossMargin,
    } = this.state;
    const { previousShownErrors } = this.props;

    return loaded ? (
      <BannerLayout
        section="FEEDBACK"
        subSection="GROSS MARGINS"
        previousShownErrors={previousShownErrors}
        alertText="Your product(s) generated insufficient margins"
        paragraph2={(
          <Fragment>
            The gross profit spread between your product’s <b>${sellingPrice.toFixed(2)}</b> average selling price and
            the <b>${unitCost.toFixed(2)}</b> average cost to manufacture each unit was <b>${(sellingPrice - unitCost).toFixed(2)}</b>, which was not enough
            to generate the gross profit margin needed to hit the <b>{Number((grossMargin * 100).toFixed(2))}%</b> gross margin target.
          </Fragment>
        )}
        visual={(
          <Fragment>
            <FormulaName background="#fec665" color="rgba(0, 27, 59, 0.94)">
              Gross Profit Margin<br />
              Per Unit of Sale
            </FormulaName>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              Selling Price - Unit Cost
              <span className='divider' />
              Selling Price
            </FormulaValue>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              ${(sellingPrice - unitCost).toFixed(2)}
              <span className='divider' />
              ${sellingPrice.toFixed(2)}
            </FormulaValue>
          </Fragment>
        )}
        visualProps={{
          borderColor: '#d5d9dd',
          background: '#fbedd5',
          flexCenter: true,
          gap: '16px',
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default GrossMarginsStep2;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/gross-margins/step2.js